import { CrossStorageClient } from 'cross-storage'

/**
 * @extends CrossStorageClient
 */
export default class StorageClient extends CrossStorageClient {
  /**
   * See {@link CrossStorageClient#onConnect}
   * @override
   */
  onConnect (): Promise<void> {
    // bodyができていないうちにiframeを作ろうとするのを回避するため
    // load or DOMContentLoaded が発生するまで待たせる
    return new Promise((resolve, reject) => {
      let connected = false
      const connect = (e) => {
        if (connected) {
          return
        }
        connected = true
        super
          .onConnect()
          .then(() => {
            resolve()
          })
          .catch(reject)
      }
      if (document.readyState === 'complete') {
        connect()
      } else {
        window.addEventListener('load', connect)
        window.addEventListener('DOMContentLoaded', connect)
      }
    })
  }

  getOrCreate (key: string, createValue: () => Promise<string>): Promise<string> {
    return Promise.resolve()
      .then(() => this.get(key))
      .then((id) => {
        if (id) {
          return id
        }
        return createValue()
      })
      .then((id) => {
        return this.set(key, id).then(() => id)
      })
  }
}
